import { render, staticRenderFns } from "./AnswerField.vue?vue&type=template&id=d015b12e&scoped=true&"
import script from "./AnswerField.vue?vue&type=script&lang=js&"
export * from "./AnswerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d015b12e",
  null
  
)

export default component.exports